window.Languages = {
    language: "en",
    supported_languages: ["en", "fr", "de", "cn", "ko", "ja", "es", "ru", "pt"],
}